module.exports = __webpack_public_path__ + "img/1.31eb1d13.jpg";